export default __webpack_public_path__ + "static/media/playstore.9157af84.png";